import React from "react";
import { Card, Text } from "@merge-api/merge-javascript-shared";

export interface TileWithImageProps {
  img?: React.ReactElement;
  title: string | JSX.Element;
  subtitle?: JSX.Element;
  stepNumber: number;
}

type DescriptionProps = {
  title: string | JSX.Element;
  subtitle?: JSX.Element;
};

const Description = ({ title, subtitle }: DescriptionProps) => (
  <div className="p-5 w-full flex justify-between items-center overflow-hidden">
    <div className="flex flex-col gap-y-2">
      <Text variant="h4">{title}</Text>
      <Text>{subtitle}</Text>
    </div>
  </div>
);

/*
 ** This is the general step component used across all sections of the onboarding
 */

const TileStep = ({ img, title, subtitle, stepNumber }: TileWithImageProps) => (
  <Card className="flex flex-col w-full">
    <div className="hidden max-[1000px]:flex items-center px-4 py-3 w-full bg-gray-0 self-start rounded-t-lg">
      <Text variant="h6">Step {stepNumber}</Text>
    </div>

    {img ? (
      <div className="grid grid-cols-[1fr_5fr] items-center">
        <div className="ml-[22px] w-[100px] h-[100px] flex justify-center items-center object-contain">
          {img}
        </div>
        <Description title={title} subtitle={subtitle} />
      </div>
    ) : (
      <Description title={title} subtitle={subtitle} />
    )}
  </Card>
);

export default TileStep;
